export default __webpack_public_path__ + "static/media/createBMBG.3bc975df.png";